export default __webpack_public_path__ + "static/media/VID-20220612-WA0001.28e98d4f.mp4";